enum PaymentTypeEnum {
    EndOfLoan = 'END_OF_LOAN',
    Monthly = 'MONTHLY',
    PrePay = 'PRE_PAY',
}

export default PaymentTypeEnum;
